<!-- <mat-grid-list [cols]="currCols" [rowHeight]="rowHeight" gutterSize="10px" *ngIf="clientCards$">

    <mat-grid-tile class="address-card add-card clicked" (click)="openDialCardSca()" angulartics2On="click" angularticsAction="openCreateDialog" angularticsCategory="paymentMethods">

        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px" class="full-screen text-center">
            <i class="material-icons great-ico" style="font-size: 2.2em;">security</i>
            <span class="mat-subheading-1">Ajouter une carte de paiement</span>
        </div>

    </mat-grid-tile>

    <mat-grid-tile *ngFor="let card of clientCards$; let index = index;" class="address-card clicked" [class.isSelected]="cardClient$ && card.id === cardClient$.id">

        <div fxLayout="column" class="layout-padd-4 full-screen">

            <div fxLayout="column" class="fill-rest layout-padd" id="inf-add" (click)="selectCardClient(card)">

                <div fxLayout="row" fxLayoutAlign="end center">

                    <div *ngIf="card.momentary" fxLayoutAlign="center center" class="secondary rad-bord layout-padd-1 noWrap">
                        <span class="mat-subheading-1 boldest">Non enregistrée</span>
                    </div>

                    <div class="fill-rest"></div>

                    <img src="{{card.card.logo_src}}" class="rad-bord logo-card">

                </div>

                <div fxLayout="column" class="fill-rest" fxLayoutAlign="center start">

                    <div>
                        <span class="mat-subheading-1">**** **** **** {{card.card.last4}}</span>
                    </div>

                    <div fxLayout="row" fxLayoutGap="5px">
                        <div>
                            <span class="mat-subheading-1" *ngIf="card.card.exp_month <= 9">{{card.card.exp_month <= 9 ? 0 : ''}}{{card.card.exp_month}}</span>
                            <span class="mat-subheading-1" *ngIf="card.card.exp_month > 9">{{card.card.exp_month}}</span>
                        </div>
                        <div>
                            <span class="mat-subheading-1">-</span>
                        </div>
                        <div>
                            <span class="mat-subheading-1">{{card.card.exp_year}}</span>
                        </div>
                    </div>

                </div>

            </div>

            <div fxLayout="row">
                <div class="fill-rest"></div>
                <span class="mat-caption warn-ico boldest" (click)="openDialDeletCard(card, index)" angulartics2On="click" angularticsAction="openDeleteDialog" angularticsCategory="paymentMethods">Supprimer</span>
            </div>

        </div>

    </mat-grid-tile>

</mat-grid-list> -->

<mat-list role="list" *ngIf="clientCards$">

    <mat-list-item *ngFor="let card of clientCards$; let index = index; let last = last;" class="rad-bord clicked" [class.isSelected]="cardClient$ && card.id === cardClient$.id" (click)="selectCardClient(card)">

        <!-- <mat-icon fxHide.xs mat-list-icon class="great-ico" *ngIf="cardClient$ && card.id === cardClient$.id">done</mat-icon> -->

        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">

            <div fxLayout="row" fxLayout="start center" fxLayoutGap="5px">
                <img src="{{card.card.logo_src}}" class="rad-bord logo-card">
                <span class="mat-subheading-1" fxHide.xs>**** **** **** {{card.card.last4}}</span>
                <span class="mat-subheading-1" fxHide fxShow.xs>**** {{card.card.last4}}</span>
            </div>

            <mat-icon class="warn-ico" (click)="openDialDeletCard(card, index); $event.stopPropagation();" angulartics2On="click" angularticsAction="openDeleteDialog" angularticsCategory="paymentMethods">delete</mat-icon>
        </div>

    </mat-list-item>

    <mat-list-item role="listitem" class="clicked" [ngStyle]="{'margin-top' : clientCards$.length > 0 ? '10px' : '0px'}" [class.divider-top]="clientCards$.length > 0" (click)="openDialCardSca()" angulartics2On="click" angularticsAction="openCreateDialog"
        angularticsCategory="paymentMethods">

        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">

            <div fxLayout="row" fxLayout="start center" fxLayoutGap="5px">
                <div fxLayoutAlign="start center">
                    <span class="mat-subheading-1">{{'CardBackOfficeClientComponent.addCard'|translate}}</span>
                </div>
                <i class="material-icons great-ico" style="font-size: 1.6em;">security</i>
            </div>

            <mat-icon class="great-ico">add</mat-icon>
        </div>

    </mat-list-item>


</mat-list>

<app-popup-loader [flagLoading]="loader" [size]="30" [statusMessage]="'CardBackOfficeClientComponent.loaderGetcard'|translate" [type]="'line'">
</app-popup-loader>